module.exports = __webpack_public_path__ + "img/profile-man-13-min.34f47cbf.jpg";